/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `update` - update
 * * `replace` - replace
 */
export enum BulkUpdateMetadataOperationEnum {
    UPDATE = 'update',
    REPLACE = 'replace',
}
